/** The markets Firmable searches, by code. Shared by the web app and the API. */
export const CountryNamesByCode: Record<AvailableCountries, string> = {
  AU: 'Australia',
  NZ: 'New Zealand',
  HK: 'Hong Kong',
  JP: 'Japan',
  MY: 'Malaysia',
  PH: 'Philippines',
  SG: 'Singapore',
  ID: 'Indonesia',
  US: 'United States',
  CA: 'Canada',
  TH: 'Thailand',
  VN: 'Vietnam',
  KR: 'South Korea',
};
